/* eslint-disable   */
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Modal, Radio, Input, Tooltip } from 'antd';
import toLower from 'lodash/toLower';
import { useTranslation } from 'react-i18next';
import { BookingStatus, pendingNoteList } from '~constants/reconciliationStatus';
import FileUpload from './FileUpload';
import { EmojiRegex } from '~helpers/validate';
import { updateOpportunityLandlordBookingStatus } from '~actions/reconciliation';

export default function CommentModal(props) {
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(true);
  const [modalConfirmLoading, setModalConfirmLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [pendingNote, setPendingNote] = useState(null);
  const [textAreaValue, setTextAreaValue] = useState('');

  const handleModalCancel = () => {
    setModalShow(false);
    props.onCancel();
  };

  const handleModalOk = () => {
    setModalConfirmLoading(true);

    const params = {
      id: props.opportunityId,
      data: {
        landlordBookingStatus: BookingStatus.PENDING_APPROVAL,
        noteData: {
          description: textAreaValue,
          files: fileList.map(file => ({
            contentType: file.response.content_type,
            name: file.response.name,
            source: file.response.source,
          })),
          pendingNote: pendingNote,
        },
      },
    };
    updateOpportunityLandlordBookingStatus(params, () => {
      setModalConfirmLoading(false);
      let newDetailsStatus = { ...props.details }; //stageComment
      newDetailsStatus.opportunityStateChanges.unshift({
        currentLandlordBookingStatus: BookingStatus.PENDING_APPROVAL,
        currentSecondaryLandlordBookingStatus: null,
        opportunityPendingNote: { ...params.data.noteData },
        updatedAt: moment(),
      });
      newDetailsStatus.landlordBookingStatus = BookingStatus.PENDING_APPROVAL;
      setModalShow(false);
      props.onSuccess(
        {
          ...params.data.noteData,
          opportunityPendingNoteFiles: params.data.noteData.files,
        },
        newDetailsStatus,
      );
    });
  };

  const textAreaOnchange = e => {
    setTextAreaValue(e.currentTarget.value);
  };

  const handleRadioChange = e => {
    setPendingNote(e.target.value);
  };

  useEffect(() => {
    setTextAreaValue('');
  }, [modalShow]);

  return (
    <Modal
      className="reconciliation-comment-modal"
      visible={true}
      maskClosable={false}
      onOk={handleModalOk}
      okText={t('landlord.booking.reconciliation.details.stage.modal.confirm')}
      okButtonProps={{ disabled: !textAreaValue.replace(/\s/gi, '') || !pendingNote }}
      confirmLoading={modalConfirmLoading}
      onCancel={handleModalCancel}
    >
      <div className="reconciliation-comment-modal__title">
        {t('landlord.booking.reconciliation.details.stage.modal.title')}
      </div>
      <div className="modaltitle modaltitle--require">
        {t('landlord.booking.reconciliation.details.stage.modal.reason')}

        <span className="reconciliation-comment-modal__subtitle">
          {t('landlord.booking.reconciliation.details.stage.modal.reason.subtitle')}
        </span>
      </div>

      <Radio.Group onChange={handleRadioChange}>
        <For of={Object.keys(pendingNoteList)} each="note">
          <Radio value={note} key={note}>
            <Tooltip
              title={t(
                `landlord.booking.reconciliation.details.modal.reason_tooltips.${toLower(note)}`,
              )}
            >
              {t(`landlord.booking.reconciliation.details.modal.reason_option.${toLower(note)}`)}
            </Tooltip>
          </Radio>
        </For>
      </Radio.Group>

      <div className="modaltitle modaltitle--require">
        {t('landlord.booking.reconciliation.details.stage.modal.description')}
      </div>
      <Input.TextArea
        onChange={textAreaOnchange}
        onInput={e => (e.currentTarget.value = e.currentTarget.value.replace(EmojiRegex, ''))}
        maxLength={500}
        placeholder={t('landlord.booking.reconciliation.details.stage.modal.placeholder')}
        autoSize={{ minRows: 5, maxRows: 5 }}
      />
      <div className="limit-number">{textAreaValue.length}/500</div>

      <div className="modaltitle">
        {t('landlord.booking.reconciliation.details.stage.modal.files')}
      </div>
      <FileUpload doneFile={setFileList} />
    </Modal>
  );
}
